/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RequirementTemplate } from './RequirementTemplate';
import {
  RequirementTemplateFromJSON,
  RequirementTemplateFromJSONTyped,
  RequirementTemplateToJSON,
} from './RequirementTemplate';

/**
 *
 * @export
 * @interface EnhancedGovernance
 */
export interface EnhancedGovernance {
  /**
   *
   * @type {number}
   * @memberof EnhancedGovernance
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof EnhancedGovernance
   */
  stage: number;
  /**
   *
   * @type {number}
   * @memberof EnhancedGovernance
   */
  requirementId: number;
  /**
   *
   * @type {string}
   * @memberof EnhancedGovernance
   */
  requirementDesc: string;
  /**
   *
   * @type {string}
   * @memberof EnhancedGovernance
   */
  infoText?: string | null;
  /**
   *
   * @type {string}
   * @memberof EnhancedGovernance
   */
  readonly stageName: string;
  /**
   *
   * @type {Array<RequirementTemplate>}
   * @memberof EnhancedGovernance
   */
  readonly templates: Array<RequirementTemplate>;
}

/**
 * Check if a given object implements the EnhancedGovernance interface.
 */
export function instanceOfEnhancedGovernance(value: object): value is EnhancedGovernance {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('stage' in value) || value['stage'] === undefined) return false;
  if (!('requirementId' in value) || value['requirementId'] === undefined) return false;
  if (!('requirementDesc' in value) || value['requirementDesc'] === undefined) return false;
  if (!('stageName' in value) || value['stageName'] === undefined) return false;
  if (!('templates' in value) || value['templates'] === undefined) return false;
  return true;
}

export function EnhancedGovernanceFromJSON(json: any): EnhancedGovernance {
  return EnhancedGovernanceFromJSONTyped(json, false);
}

export function EnhancedGovernanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnhancedGovernance {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    stage: json['stage'],
    requirementId: json['requirement_id'],
    requirementDesc: json['requirement_desc'],
    infoText: json['info_text'] == null ? undefined : json['info_text'],
    stageName: json['stage_name'],
    templates: (json['templates'] as Array<any>).map(RequirementTemplateFromJSON),
  };
}

export function EnhancedGovernanceToJSON(
  value?: Omit<EnhancedGovernance, 'id' | 'stageName' | 'templates'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    stage: value['stage'],
    requirement_id: value['requirementId'],
    requirement_desc: value['requirementDesc'],
    info_text: value['infoText'],
  };
}
